import React from 'react';
import language from '../../../../../assets/languages/language';

function OverallGraph({
  average,
  totalMarks,
  dataOfCurrentUser,
  dataOfTwentyPercentileUser,
  dataOfEightyPercentileUser,
}) {
  return (
    <div className='chart-graph-wrapper'>
      <h1 className='overAllScore'>{`${language.LC().OVERALLRESULT}`}</h1>

      <div className='row align-items-center'>
        <div className='col-lg-6'>
          {' '}
          <div id='chartContainerOverAllGraph' className='js-chart-wrap' />
          <ul className='legend-wrapper'>
            <li>
              <span className='square-box' /> {language.LC().SCOREBOX}
            </li>
            <li>
              <span className='line-dash' /> {language.LC().Percentile_20}
            </li>
            <li>
              <span className='line-dots' /> {language.LC().Percentile_80}
            </li>
            <li>
              <span className='line-normal' /> {language.LC().YOURSCORE}
            </li>
          </ul>
        </div>
        <div className='col-lg-6'>
          <div className=' graphData'>
            <div className='graphScoreData'>
              <div className='graphScore'>{`${
                dataOfTwentyPercentileUser
                  ? Math.ceil((dataOfTwentyPercentileUser / totalMarks) * 100)
                  : 0
              }%`}</div>
              <div className='graphLabel'>
                <span className='percentileTwentyScore-box' />{' '}
                {language.LC().Percentile_20}
              </div>
            </div>
            <div className='graphScoreData'>
              <div className='graphScore'>{`${
                dataOfEightyPercentileUser
                  ? Math.ceil((dataOfEightyPercentileUser / totalMarks) * 100)
                  : 0
              }%`}</div>
              <div className='graphLabel'>
                <span className='percentileEightyScore-box' />{' '}
                {language.LC().Percentile_80}
              </div>
            </div>
            <div className='graphScoreData'>
              <div className='graphScore'>{`${
                dataOfCurrentUser
                  ? Math.ceil((dataOfCurrentUser / totalMarks) * 100)
                  : 0
              }%`}</div>
              <div className='graphLabel'>
                <span className='score-box' /> {`${language.LC().YOURSCORE}`}
              </div>
            </div>
            <div className='graphScoreData'>
              <div className='graphScore'>{`${
                dataOfCurrentUser ? Math.ceil((average / totalMarks) * 100) : 0
              }%`}</div>
              <div className='graphLabel'>
                <span className='average-box' /> {language.LC().AVERAGE_SCORE}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverallGraph;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/ResultGraph/OverallGraph/OverallGraph.jsx